<svg class="barcode" id="{{id}}">
{{ value }}
</svg>